import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Parameter } from "@/v2/models/parameters";

export class TaxClass extends DataObject {
    _type = "tax_class";

    id;
    code;
    name;
    percentage;
    created_at;
    updated_at;
    visible;
}

export class TaxClassMapperParameter extends Parameter {
    taxClassMapper;
}

export class TaxClassFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {TaxClassMapperParameter} taxClassMapperParameter Parameter object containing mappers that the factory expects.
     * @param {Object, null} data Data to construct the StockTakeEvent object with.
     * @returns {TaxClass}
     */
    static construct(taxClassMapperParameter, data = null) {
        if (data != null) {
            let taxClass = DataObjectFactory.getInstance().construct(
                TaxClass,
                data ? taxClassMapperParameter.taxClassMapper(data) : null
            );
            return taxClass;
        }

        return null;
    }
}
